import { Flex } from '@interco/inter-ui/components/Flex'
import { Text } from '@interco/inter-ui/components/Text'

interface Props {
  title: string | JSX.Element
  titleVariant?: 'caption-1' | 'body-3'
  value: string | number | JSX.Element
}

export const FlexRow = ({ title, value, titleVariant = 'body-3' }: Props) => (
  <Flex direction="row">
    <Text variant={titleVariant}>{title}</Text>
    <Text variant={titleVariant} bold colorWeight={500}>
      {value}
    </Text>
  </Flex>
)
